/* eslint-disable */
var $ = window.jQuery = require('jquery');
import toast from '../../services/toast';
import { mapGetters } from 'vuex';

export default {
  name: 'public-quiz-history',
  components: {},
  props: [],
  data() {
    return {
      quizData:{
        quizId:''
      },
      coursesId:'',
      quizQuesDetails:'',
      quiezzesHistory:'',
      pub_catID:''
    }
  },
  computed: {
    ...mapGetters([
      'getQuizDetailsByIdDataState',
      'getQuizzesHistoryDataState'
    ]),
    getQuizQuesDetails() {
      this.quizQuesDetails = this.$store.getters.getQuizDetailsByIdDataState
      return this.quizQuesDetails
    },
    getQuizzesHistory(){
      this.quiezzesHistory = this.$store.getters.getQuizzesHistoryDataState.data
      return this.quiezzesHistory
    }
  },
  mounted() {
    this.pub_catID = this.$route.params.quiz_catId,
    this.getQuizzesHistory
    this.getQuizQuesDetails
    this.quizData.quizId = this.$route.params.quizId;
  },
  methods: {
  },
  beforeMount() {
  },
  watch: {
    getQuizQuesDetails() {
      return this.$store.getters.getQuizDetailsByIdDataState
    },
    getQuizzesHistory(){
      return this.$store.getters.getQuizzesHistoryDataState
    }
  },
}